export default __webpack_public_path__ + "5b1fd340ce2a39fae6d9e5207916b5e5.gif";